import { CircularProgress, Collapse } from "@mui/material";
import ExpandControl from "src/components/general/ExpandControl/ExpandControl";
import { TestsStatusIcon } from "@ui-icons";
import { EXPAND_CONTROL_PROPS } from "../../../../../AiAssistantExpandableTree/AiAssistantExpandableTree.constants";
import { getExpandableFrameClassName } from "../../../../../AiAssistantExpandableTree/AiAssistantExpandableTree.utils";
import AiAssistantExpandableButton from "../../../../../AiAssistantExpandableTree/components/AiAssistantExpandableButton/AiAssistantExpandableButton";
import type { ToolCallNodePendingProps } from "../../../../ToolCallIndicator.types";
import ToolCallIndicatorNodeNameLabel from "../ToolCallIndicatorNodeNameLabel/ToolCallIndicatorNodeNameLabel";
import ToolCallIndicatorNodeOptionalInputBlock from "../ToolCallIndicatorNodeOptionalInputBlock/ToolCallIndicatorNodeOptionalInputBlock";

export default function ToolCallIndicatorNodePending({
  toolCallId,
  name,
  input,
  hasInputParseError,
}: ToolCallNodePendingProps) {
  return (
    <div data-tool-call-id={toolCallId}>
      <ExpandControl {...EXPAND_CONTROL_PROPS}>
        {({ isExpanded, ToggleButton, toggleExpand }) => (
          <div className={getExpandableFrameClassName(isExpanded)}>
            <AiAssistantExpandableButton onClick={toggleExpand}>
              <CircularProgress size={10} className="mr-1 leading-0" />
              {ToggleButton}
              <ToolCallIndicatorNodeNameLabel name={name} />
              <TestsStatusIcon status="warning" className="animate-pulse" />
            </AiAssistantExpandableButton>
            <Collapse in={isExpanded}>
              <div className="pl-6 pb-1">
                <ToolCallIndicatorNodeOptionalInputBlock
                  input={input}
                  hasInputParseError={hasInputParseError}
                  layout="pending"
                  wrapInTreeItem={false}
                />
              </div>
            </Collapse>
          </div>
        )}
      </ExpandControl>
    </div>
  );
}
